import { instanceApi } from './instance';

// Send UTM
export const sendUtm = (utms: any): Promise<void> => instanceApi.post(`api/utm?${utms}`);

// Send UTM to hubspot
export const sendUtmToHubspot = (utms: any): Promise<void> => instanceApi.post(`api/hubspot/contact?${utms}`);
